import { ArrowRight, Lightbulb } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { IndexPath } from '@/Config/app/router/index.path';
import { Button } from '@/Domain/components/Shared/Button/Button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/Domain/components/Shared/Empty/Empty';

export const EmptyInsightsState = () => {
  const { t } = useTranslation('insights_page', { keyPrefix: 'unified_ai_insights.empty' });
  const { scenario } = useParams<{ scenario: string }>();

  const examplesRaw = t('examples', { returnObjects: true });
  const examples: string[] = Array.isArray(examplesRaw) ? examplesRaw : [];

  return (
    <Empty data-testid="empty-insights-state">
      <EmptyHeader className="w-full items-start text-left">
        <EmptyMedia variant="icon">
          <Lightbulb />
        </EmptyMedia>
        <EmptyTitle>{t('title')}</EmptyTitle>
        <EmptyDescription>{t('description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent className="items-start text-left">
        <div className="w-full text-left space-y-2">
          <p className="text-sm font-medium text-foreground">{t('examples_heading')}</p>
          <ul className="space-y-1.5 text-sm text-muted-foreground text-wrap">
            {examples.map((example) => (
              <li key={example} className="flex items-start gap-2">
                <span className="mt-1.5 size-1 shrink-0 rounded-full bg-muted-foreground" />
                <span>{example}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex w-full flex-col gap-2">
          <Button
            asChild
            variant="dark"
            size="md"
            className="w-full"
            data-testid="empty-insights-cta-website"
          >
            <Link to={`/i/${scenario}/${IndexPath.website}`}>
              {t('cta_website')}
              <ArrowRight />
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            size="md"
            className="w-full"
            data-testid="empty-insights-cta-messaging"
          >
            <Link to={`/i/${scenario}/${IndexPath.channels}`}>
              {t('cta_messaging')}
              <ArrowRight />
            </Link>
          </Button>
        </div>
        <p className="w-full text-center text-xs text-foreground-subtle">{t('cta_subtext')}</p>
      </EmptyContent>
    </Empty>
  );
};
